<template>
    <main class="container">
        <section>
            <div class="row">
                <div class="col">
                    <h1>Setup Wi-Fi</h1>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-outline-dark text-nowrap float-end" style="width: 16rem" @click="configureWifi()">Manual Setup</button>
                </div>
            </div>
            <p>Select a Wifi connection, enter password and wait for connection to be completed.</p>
            

        </section>

        <section v-if="GoConnect.loading.wifiNetworks" class="loading">
            <div style="margin-top: auto; margin-bottom: auto">
                <div class="spinner-border" role="status" style="width: 6rem; height: 6rem; margin: 1rem;">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p id="loading_text"> Refreshing details please wait...</p>
            </div>
        </section>

        <div v-else class="table-responsive">
            <table class="table table-hover table-striped">
                <thead>
                    <tr>
                        <th>Network Name</th>
                        <th style="text-align: right">Strength</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="network in GoConnect.device.wifiNetworks" :key="network.ssid"
                        @click="configureWifi(network)">
                        <td>{{ network.ssid }}</td>
                        <td style="text-align: right">
                            <span v-if="network.signal <= -70" class="text-danger">
                                {{ network.signal }}
                            </span>
                            <span v-else-if="network.signal < -67" class="text-danger-emphasis">
                                {{ network.signal }}
                            </span>
                            <span v-else-if="network.signal < -60" class="text-warning">
                                {{ network.signal }}
                            </span>
                            <span v-else-if="network.signal < -50" class="text-warning-emphasis">
                                {{ network.signal }}
                            </span>
                            <span v-else-if="network.signal < -30" class="text-success-emphasis">
                                {{ network.signal }}
                            </span>
                            <span v-else-if="network.signal >= -30" class="text-success">
                                {{ network.signal }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class=" row">
            <div class="col-2"><button class="btn btn-dark btn-lg" @click="router.back(-1)">
                    <i class="fas fa-arrow-left"></i>
                </button>
            </div>
            <template v-if="route.meta.mode == 'setup'">
                <div class="col-5">
                    <router-link class="btn btn-dark btn-lg" to="/setup/3">
                        Setup another connection type
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link class="btn btn-dark btn-lg" to="/device/audio">
                        Continue
                    </router-link>
                </div>
            </template>
            <template v-else>
                <div class="col-10">
                    <router-link class="btn btn-dark btn-lg" to="/device/network">
                        Setup another connection type
                    </router-link>
                </div>
            </template>
        </div>

        <div class="modal fade" id="wirelessSetupModal" tabIndex="-1" aria-labelledby="wirelessSetupModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title" id="wirelessSetupModalLabel">Configure Wi-Fi network</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <div v-if="wifiConnectionErrorMessage" class="alert alert-danger row" role="alert">
                            <div class="col-1 align-self-center">
                                <i class="alert-icon fas fa-exclamation-circle  fa-2x"></i>
                            </div>
                            <div class="col-11">
                                <span>{{ wifiConnectionErrorMessage }}</span>
                            </div>
                        </div>
                        <div v-if="wifiConnectionIsLoading" class="alert alert-info row" role="alert">
                            <div class="col-1 align-self-center">
                                <div class="spinner-border text-info" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div class="col-11">
                                <span>Trying to connect to {{ selectedNetwork.ssid }}</span>
                            </div>
                        </div>

                        <form>
                            <div class="mb-3">
                                <label for="ssid" class="form-label">SSID</label>
                                <input type="text" class="form-control" id="ssid" v-model="selectedNetwork.ssid" required>
                            </div>
                            <div class="mb-3">
                                <label for="password" class="form-label">Password</label>
                                <input type="password" class="form-control" required id="password"
                                    v-model="selectedNetwork.password" @keyup.enter="connectWifiNetwork">
                            </div>
                        </form>

                        <div class="row">
                            <!-- Forget button disabled since it doesn't do anything currently (2023-08-18)-->
                            <!--<div class="col-12 col-sm-4">-->
                            <div class="col-12 col-sm-6">
                                <button type="button" class="btn btn-dark btn-lg" data-bs-dismiss="modal">
                                    <i class="far fa-times-circle"></i>
                                    Close
                                </button>
                            </div>
                            <!--<div class="col-12 col-sm-4">
                                <button type="button" class="btn btn-dark btn-lg" @click="forgetWifiNetwork">
                                    <i class="fas fa-trash-alt fa-sm"></i>
                                    Forget
                                </button>
                            </div>-->
                            <!--<div class="col-12 col-sm-4">-->
                            <div class="col-12 col-sm-6">
                                <button type="button" class="btn btn-dark btn-lg" @click="connectWifiNetwork">
                                    <i class="fas fa-wifi fa-sm"></i>
                                    Connect
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { Modal } from 'bootstrap';
import {
    inject, onMounted, reactive, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const GoConnect = inject('GoConnect');

const wifiConnectionErrorMessage = ref('');
const wifiConnectionIsLoading = ref(false);
const selectedNetwork = reactive({
    ssid: '',
    password: '',
});

let modal = null;

function configureWifi(network) {
    if(network && network.ssid) {
        selectedNetwork.ssid = network.ssid;
    }
    modal = new Modal(document.getElementById('wirelessSetupModal'));
    modal.show();
}

async function connectWifiNetwork() {
    try {
        wifiConnectionIsLoading.value = true;
        wifiConnectionErrorMessage.value = '';

        await GoConnect.connectWifiNetwork(selectedNetwork.ssid, selectedNetwork.password);
        wifiConnectionIsLoading.value = false;

        modal.hide();
        if (route.meta.mode === 'setup') {
            router.push({ path: '/setup/3' });
        } else {
            router.push({ path: '/device/network' });
        }
    } catch (error) {
        wifiConnectionIsLoading.value = false;
        wifiConnectionErrorMessage.value = error;
        selectedNetwork.password = '';
    }
}

/*
function forgetWifiNetwork() {
    GoConnect.forgetWifiNetwork();
}
*/

onMounted(() => {
    /*if (GoConnect.device.name === null || GoConnect.device.name.trim() === '') {
        GoConnect.onDisconnect();
    } else {*/
        GoConnect.fetchWifiNetworks();
    //}
});

</script>
